var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "payment-method-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _vm.showSelectPayment
        ? _c(
            "h3",
            {
              staticClass: "col xs-12 !pl-0",
              attrs: { id: "payment-method-title" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.checkoutSharedContent.selectPaymentMethod) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showSelectPayment
      ? _c(
          "div",
          {
            staticClass:
              "col !pl-0 flex flex-wrap justify-start payment-select-wrapper",
          },
          [
            _c("vSelect", {
              staticClass: "col xs-12 md-4 lg-5 xl-5 payment-method-input",
              attrs: {
                id: "payment-method",
                placeholder: _vm.checkoutSharedContent.selectPaymentMethod,
                options: _vm.filteredAvailablePaymentMethods,
                reduce: (displayName) => displayName.code,
                label: "displayName",
                value: _vm.paymentMethod ?? _vm.availablePaymentMethods?.[0],
              },
              on: { input: _vm.setPaymentMethod },
            }),
            _vm._v(" "),
            _vm.isENT
              ? _c(
                  "div",
                  {
                    staticClass:
                      "po-wrapper md:flex mt-1 md:mt-0 md:ml-5 w-full items-center",
                  },
                  [
                    _c("label", { attrs: { for: "PONumber" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.checkoutSharedContent.paymentMethodNames.PONumber
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { name: "PONumber", type: "text" },
                      domProps: { value: _vm.PONumber },
                      on: { input: _vm.handlePOChange },
                    }),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.paymentMethod === "Invoice"
      ? _c("div", { staticClass: "po-notice" }, [
          _c("div", { staticClass: "flex mb-1/2" }, [
            _c("input", {
              staticClass: "mt-0",
              attrs: {
                id: "order-form",
                name: "sign-order-form",
                type: "radio",
                checked: "",
              },
              on: { change: _vm.handlePDFChange },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "mb-0 ml-1/2 font-normal !pb-0 dark-blue-text leading-tight",
                attrs: { for: "order-form" },
              },
              [_vm._v(_vm._s(_vm.checkoutSharedContent.notices.order_form))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("input", {
              staticClass: "mt-0",
              attrs: {
                id: "po-document",
                name: "sign-order-form",
                type: "radio",
              },
              on: { change: _vm.handlePDFChange },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "mb-0 ml-1/2 font-normal !pb-0 dark-blue-text leading-tight",
                attrs: { for: "po-document" },
              },
              [_vm._v(_vm._s(_vm.checkoutSharedContent.notices.po_document))]
            ),
          ]),
          _vm._v(" "),
          _vm.sendPDF
            ? _c("div", [
                _c(
                  "p",
                  { staticClass: "!pb-0 dark-blue-text leading-tight !mt-1/2" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.checkoutSharedContent.notices.owner_email.replace(
                            "__owner_email__",
                            _vm.ownerEmail
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: `mailto:${_vm.ownerEmail}?subject=WEBSTORE ORDER PO`,
                    },
                  },
                  [_vm._v("Click here to send your PDF")]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showSelectPayment
      ? _c("div", { staticClass: "row !pl-0" }, [
          !_vm.isPmUpdate
            ? _c(
                "p",
                {
                  staticClass: "col leading-tight xs-12 md-10 !pl-0",
                  attrs: { id: "disclaimer" },
                },
                [_vm._v("\n      " + _vm._s(_vm.disclaimer) + "\n    ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }